import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Loading } from '../ui/loading.js';
import { useApp } from '../../contexts/AppContext.js';
import { useAuth, RedirectToSignIn } from '@clerk/clerk-react';

/**
 * Inner component that uses Clerk hooks - only rendered when Clerk is available
 */
function ProtectedRouteWithClerk({ children }) {
    const { isLoaded, isSignedIn } = useAuth();
    // Show loading while Clerk loads
    if (!isLoaded) {
        return jsx(Loading, { fullScreen: true, size: "lg", text: "Checking authentication..." });
    }
    // Redirect to sign in if not authenticated
    if (!isSignedIn) {
        return jsx(RedirectToSignIn, {});
    }
    // User is authenticated, render the protected content
    return jsx(Fragment, { children: children });
}
/**
 * Protected route wrapper that requires authentication.
 * When Clerk is not configured, shows an error message instead of crashing.
 */
function ProtectedRoute({ children }) {
    const { config, loading } = useApp();
    // Show loading while config is being fetched
    if (loading) {
        return jsx(Loading, { fullScreen: true, size: "lg", text: "Initializing..." });
    }
    // If Clerk is not configured, show an error
    if (!config?.clerkPublishableKey) {
        return (jsx("div", { className: "flex h-screen items-center justify-center", children: jsxs("div", { className: "text-center", children: [jsx("h1", { className: "text-2xl font-bold text-destructive", children: "Authentication Not Configured" }), jsx("p", { className: "mt-2 text-muted-foreground", children: "Please configure Clerk authentication to access this application." })] }) }));
    }
    // Clerk is configured, use the protected route with Clerk hooks
    return jsx(ProtectedRouteWithClerk, { children: children });
}

export { ProtectedRoute };
//# sourceMappingURL=ProtectedRoute.js.map
